import { useState } from 'react';
import styled from 'styled-components';

import Image from 'next/image';
import { useRouter } from 'next/router';
import { SOLUTIONS_ITEMS_V2 } from 'shared/components/NavBar-v2/SubMenuItems';
import useTranslation from 'shared/hooks/useTranslation';

import Card from './Card';

const StyledSection = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  margin: 0 auto;
  max-width: 240rem;
  width: 100%;

  @media ${({ theme }) => theme.DEVICE.XL} {
    grid-template-columns: 6fr 7fr;
  }
`;

const ImageWrapper = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
  top: 0;
`;

const HeadingSection = styled.div`
  position: relative;
  height: 100%;
  min-height: 30rem;
`;

const Heading = styled.h3`
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-family: ${({ theme }) => theme.FONTS.MAIN};
  line-height: 2.2rem;
  font-size: 1.4rem;
  font-weight: 600;
  margin-top: 10%;
  padding: 5rem 3.2rem;
  position: relative;
  text-align: left;
  z-index: 1;

  :before {
    background: white;
    bottom: 0;
    content: '';
    height: 2px;
    left: 3.2rem;
    position: absolute;
    width: 20%;
  }

  @media ${({ theme }) => theme.DEVICE.LG} {
    line-height: 4.5rem;
    font-size: 3rem;
    font-weight: 600;
  }
`;

const GridSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 25rem 25rem;
  width: 100%;

  @media ${({ theme }) => theme.DEVICE.LG} {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 40rem 40rem;
  }
`;

function FindOutMore(): JSX.Element {
  const { t } = useTranslation('common');

  const router = useRouter();

  function generatePageIndexArray() {
    const array: number[] = [];
    const availableIndexArray = Array.from(Array(SOLUTIONS_ITEMS_V2.length - 1).keys());
    availableIndexArray.sort(() => Math.random() - 0.5).slice(0, 5);
    availableIndexArray.map((index) => {
      if (SOLUTIONS_ITEMS_V2[index].link !== router.pathname) {
        array.push(index + 1);
      }
      return null;
    });
    return array.slice(0, 4);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [indexArray, setPageIndexArray] = useState(generatePageIndexArray());

  return (
    <StyledSection>
      <HeadingSection>
        <Heading>{t('findOutMore')}</Heading>
        <ImageWrapper>
          <Image
            src="/img/collecting-reviews/person-with-laptop-desktop.png"
            alt="find out more"
            layout="fill"
            objectFit="cover"
            quality="60"
            objectPosition="center top"
          />
        </ImageWrapper>
      </HeadingSection>
      <GridSection>
        <Card selectedItem={indexArray} />
      </GridSection>
    </StyledSection>
  );
}

export default FindOutMore;
